"use client";

import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactNode, useState } from "react";

const AccordeonTransition = ({
  children,
  title,
  className,
}: {
  children: ReactNode;
  title: ReactNode;
  className?: string;
}) => {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className={`${className}  flex flex-col overflow-hidden rounded-lg bg-white border border-gray-200`}>
      <button
        onClick={() => setShowMore((cur) => !cur)}
        className={`${showMore ? 'bg-gray-100' : 'bg-white'} text-left text-sm md:text-base transition-colors duration-300 w-full p-3 md:p-5  justify-between flex `}
      >
        <span> {title}</span>
        <FontAwesomeIcon icon={faChevronDown} className={`${showMore ? "rotate-180" : "rotate-0"} w-5 min-w-5 transition-transform duration-300`} />
      </button>
      <div
        className={`${showMore ? "grid-rows-[1fr]" : "grid-rows-[0fr] "} 
      peer-open:  grid 
       transition-[grid-template-rows] duration-500`}
      >
        <div
          className={`flex px-5 text-sm md:text-base flex-col gap-2 overflow-hidden transition-all duration-300 ${showMore ? "mt-2" : "mt-0"}`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default AccordeonTransition;
